// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DingtalkOutlinedSvg from "@ant-design/icons-svg/es/asn/DingtalkOutlined";
import AntdIcon from '../components/AntdIcon';

var DingtalkOutlined = function DingtalkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DingtalkOutlinedSvg
  }));
};

DingtalkOutlined.displayName = 'DingtalkOutlined';
export default React.forwardRef(DingtalkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DingtalkOutlined.js
// module id = 943
// module chunks = 0